import type {
  CatalogReference,
  ItemType as ItemTypeV1,
} from '@wix/auto_sdk_ecom_current-cart';
import type {
  ItemQuantityInfo,
  ItemSource,
  ItemType,
} from '@wix/auto_sdk_ecom_current-cart-v-2';

export const getCatalogAppIds = (items?: { source?: ItemSource }[]): string => {
  return getMappedUniqueList(
    items,
    ({ source }) => source?.catalogReference?.appId,
  );
};

export const getCatalogAppIdsV1 = (
  items?: { catalogReference?: CatalogReference }[],
): string => {
  return getMappedUniqueList(
    items,
    ({ catalogReference }) => catalogReference?.appId,
  );
};

export const getItemTypes = (
  items?: { attributes?: { itemType?: ItemType } }[],
): string => {
  return getMappedUniqueList(
    items,
    ({ attributes }) => attributes?.itemType?.preset,
  );
};

export const getItemTypesV1 = (items?: { itemType?: ItemTypeV1 }[]): string => {
  return getMappedUniqueList(items, ({ itemType }) => itemType?.preset);
};

export const getItemsCount = (
  items?: { quantityInfo?: ItemQuantityInfo }[],
): number => {
  return (
    items?.reduce(
      (count, item) => count + (item.quantityInfo?.confirmedQuantity ?? 0),
      0,
    ) ?? 0
  );
};

export const getItemsCountV1 = (items?: { quantity?: number }[]): number => {
  /* istanbul ignore next */
  return items?.reduce((count, item) => count + (item.quantity ?? 0), 0) ?? 0;
};

function getMappedUniqueList<T>(
  arr: T[] | undefined,
  mapper: (t: T) => string | undefined | null,
): string {
  return getUniques(
    (arr ?? /* istanbul ignore next */ [])
      .map(mapper)
      .filter(isDefined) as string[],
  ).toString();
}

const getUniques = (arr: string[]): string[] => {
  return [...new Set([...arr])];
};

const isDefined = <T>(obj: T): boolean => {
  return !!obj;
};
